import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VESSEL_LAST_VOYAGES, TVesselLastVoyagesSliceState, TVesselInfo } from '../mapTypes';

const initialState: TVesselLastVoyagesSliceState = {
    vesselLastVoyagesData: null,
    vesselLastVoyagesLoading: false,
    vesselLastVoyagesError: null,
};

const vesselLastVoyagesSlice = createSlice({
    name: VESSEL_LAST_VOYAGES,
    initialState,
    reducers: {
        emptyVesselLastVoyagesAction: (state: TVesselLastVoyagesSliceState) => {
            state.vesselLastVoyagesData = null;
            state.vesselLastVoyagesLoading = false;
            state.vesselLastVoyagesError = null;
        },
        getVesselLastVoyagesRequestAction: (state: TVesselLastVoyagesSliceState, _: PayloadAction<{ imoNumbers: number[], startDate: string, endDate: string }>) => {
            state.vesselLastVoyagesLoading = true;
            state.vesselLastVoyagesError = null;
        },
        getVesselLastVoyagesSuccessAction: (
            state: TVesselLastVoyagesSliceState,
            { payload: data }: PayloadAction<TVesselInfo>,
        ) => {
            state.vesselLastVoyagesLoading = false;
            state.vesselLastVoyagesData = data;
            state.vesselLastVoyagesError = null;
        },
        getVesselLastVoyagesErrorAction: (
            state: TVesselLastVoyagesSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            state.vesselLastVoyagesData = null;
            state.vesselLastVoyagesLoading = false;
            state.vesselLastVoyagesError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});

export const { getVesselLastVoyagesRequestAction, getVesselLastVoyagesSuccessAction, getVesselLastVoyagesErrorAction, emptyVesselLastVoyagesAction } =
    vesselLastVoyagesSlice.actions;
export default vesselLastVoyagesSlice.reducer;
